import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import {
	DEFAULT_LOAD_MORE,
	DEFAULT_PAGE_NUMBER,
} from '../../../../../constants';
import { clientBankIdentityRoute } from '../../route';

import { getClientBankIdentityHistoryOfUseFilterFormSchema } from './ClientBankIdentityHistoryOfUseFilter/helpers/getClientBankIdentityHistoryOfUseFilterFormSchema';

const clientBankIdentityHistoryOfUseFilterFormSchema =
	getClientBankIdentityHistoryOfUseFilterFormSchema();

export const authoritiesAndTheStatePageValidateSearchSchema = z.object({
	openedActivityUuid: z.string().optional(),
	pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	filter: clientBankIdentityHistoryOfUseFilterFormSchema.catch({}),
});

export const authoritiesAndTheStateRoute = createRoute({
	path: '/authorities-and-the-state',
	getParentRoute: () => clientBankIdentityRoute,
	component: lazyRouteComponent(
		() => import('./AuthoritiesAndTheStatePage'),
		'AuthoritiesAndTheStatePage',
	),
	validateSearch: authoritiesAndTheStatePageValidateSearchSchema,
});
